export const parseDate = function(stringDate) {
  const date = new Date(stringDate);
  const month = function() {
    const montList = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    return montList[date.getMonth()];
  };
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
  const timeOfDay = hours <= 12 ? "am" : "pm";
  const minutes =
    date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();

  return `${month()} ${day}, ${year}`;
};

export const parseDateShort = function(stringDate) {
  const date = new Date(stringDate);
  const day = () => {
    const day = date.getDate();
    return day < 10 ? `0${day}` : day;
  };
  const month = () => {
    const month = date.getMonth() + 1;
    return month < 10 ? `0${month}` : month;
  };
  const year = date.getFullYear();

  return `${day()}.${month()}.${year}`;
};

export const cutString = function(str, length) {
  return str.length > length ? str.substr(0, length - 3) + "..." : str;
};

export const getSequence = function(n, offset = 0) {
  const sequence = [];
  for (let i = 0; i < n; i++) {
    sequence.push(i + offset);
  }
  return sequence;
};
